import { SVGProps, Ref, forwardRef } from 'react';

export const ConstructionHatOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M17.5 17.9h-11v-1.8h11z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.38 2c1.72 0 2.58 0 3.152.518.25.226.407.518.519.919 5.225 1.312 6.668 5.6 6.908 12.949A3.28 3.28 0 0 1 24 18.778c0 1.342-.84 2.487-2.168 2.683-1.779.262-4.838.539-9.832.539s-8.053-.277-9.832-.54C.841 21.266 0 20.12 0 18.779c0-.935.397-1.79 1.04-2.392.24-7.348 1.683-11.636 6.908-12.95.112-.4.27-.692.52-.918.428-.388 1.02-.486 2.014-.51L11.62 2zM7.66 5.4c-1.3.452-2.17 1.138-2.796 1.992-1.278 1.743-1.88 4.587-2.025 9.052l-.025.745-.543.51c-.295.276-.471.661-.471 1.08 0 .297.093.52.202.659.1.127.235.213.429.242 1.67.246 4.638.52 9.569.52s7.9-.274 9.57-.52a.64.64 0 0 0 .428-.242c.109-.139.202-.362.202-.66 0-.417-.176-.802-.471-1.079l-.544-.51-.025-.745c-.145-4.465-.747-7.31-2.024-9.052-.626-.855-1.498-1.54-2.798-1.993l.01.099q.008.051.012.104L17.1 13h-1.81l-.72-7.219c-.091-.903-.145-1.409-.227-1.762a2 2 0 0 0-.04-.145 2 2 0 0 0-.146-.024c-.36-.047-.869-.05-1.777-.05h-.76c-.908 0-1.417.003-1.777.05q-.093.013-.147.024a2 2 0 0 0-.039.145c-.082.353-.136.859-.226 1.762L8.709 13H6.9l.74-7.398z"
                fill="currentColor"
            />
        </svg>
    )
);
ConstructionHatOutlinedSize24Glyph.displayName = 'ConstructionHatOutlinedSize24Glyph';
